import { readEnv } from '@repo/helpers';
import { BodyTextXS, cs } from "@repo/ui";

const Version = () => {
	return (
		<BodyTextXS
			sx={{
				mb: 0,
				px: { md: 0, xs: 4 },
				color: "grey.main",
				textAlign: "right",
			}}
		>{`${cs.global.portalVersion} ${readEnv('GATSBY_VERSION')}`}</BodyTextXS>
	);
};

export default Version;
